import Types from "../../constants/Types.js";
import { Id } from "../builders/index.js";
export default Id({
  objectType: Types.firmwareRelease
});